import { createSelector } from 'reselect';
import { preAssessmentDetails } from '@/selectors/merchant';

export const getDefaultState = createSelector(
  preAssessmentDetails,
  ({
    averageOrderValue,
    companyName,
    goodsCategory,
    isManaged,
    operatingCountry,
    registrationAuthority,
    registrationCountry,
    registrationNumber,
    storeUrl,
    volumeByCard,
    vatNumber,
  }) => ({
    averageOrderValue,
    companyName,
    goodsCategory,
    isManaged,
    operatingCountry,
    registrationAuthority,
    registrationCountry,
    registrationNumber,
    storeUrl,
    volumeByCard,
    vatNumber,
  }),
);
